export default {
    1: {
        id: 1,
        text: 'Pending',
        type: 'warning'
    },
    2: {
        id: 2,
        text: 'Informed',
        type: 'success'
    },
    3: {
        id: 3,
        text: 'Error',
        type: 'danger'
    },
};
